import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Permission } from '@core/permissions/models/permissions.models';
import { PermissionsService } from '@core/permissions/services/permissions.service';

export const AdminGroupDetailsGuard: CanActivateFn = () => {
  const permissionsService: PermissionsService = inject(PermissionsService);
  return (
    permissionsService.hasAdministrationAccess() &&
    permissionsService.canViewAdminGroups() &&
    permissionsService.can(Permission.OPEN_GROUP_DETAILS)
  );
};
